import { render, staticRenderFns } from "./ResourcesTable.vue?vue&type=template&id=147cb221&scoped=true"
import script from "./ResourcesTable.vue?vue&type=script&lang=js"
export * from "./ResourcesTable.vue?vue&type=script&lang=js"
import style0 from "./ResourcesTable.vue?vue&type=style&index=0&id=147cb221&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147cb221",
  null
  
)

export default component.exports